// extracted by mini-css-extract-plugin
export var background = "styles-module--background--ea2c8";
export var bullet = "styles-module--bullet--9d698";
export var button = "styles-module--button--ffc24";
export var circlesLeft = "styles-module--circlesLeft--7362f";
export var circlesRight = "styles-module--circlesRight--1a7e8";
export var container = "styles-module--container--0c06d";
export var dark = "styles-module--dark--a29e9";
export var image = "styles-module--image--544dc";
export var imageColumn = "styles-module--imageColumn--bdcb7";
export var items = "styles-module--items--4d0d5";
export var light = "styles-module--light--f1aa0";
export var link = "styles-module--link--4ef95";
export var middle = "styles-module--middle--ce973";
export var stepsColumn = "styles-module--stepsColumn--040f0";
export var title = "styles-module--title--3ba56";
export var vertical = "styles-module--vertical--b265d";